import * as angular from "angular";
import { StateParams, StateService } from "@uirouter/core";

declare var $: any;

export class RastreamentoController implements angular.IController {
  public infoRastreio =
    "Por favor aguarde, estamos buscando as informações da sua encomenda...";
  public numeroRastreio: string;
  public alerts = [];
  public encomenda;
  public ajustaColuna;
  public mostrarDetalhes = false;
  public mostrarDetalhesReversa = false;
  public emailVero = false;

  constructor(
    private $stateParams: StateParams,
    private $state: StateService,
    private $timeout: angular.ITimeoutService,
    private $filter: angular.IFilterService,
    private Rastreamento,
    private Auth
  ) {}

  public async $onInit() {
    this.numeroRastreio = this.$stateParams.numeroRastreio;

    // This page is part of the signed-in app: without a session the user signs in first.
    if (!this.isLoggedIn()) {
      window.location.href = "/login";
      return;
    }

    try {
      const status = await this.Rastreamento.getRastreio(this.numeroRastreio);

      if (status.redirecionamento) {
        window.open(status.urlRedirecionamento, "_self");
      } else {
        this.ajustaColuna =
          this.$filter("filter")(status.historico, { exibirAlerta: true })
            .length > 0;
        this.encomenda = status;
        if (this.encomenda.destinatario.email) {
          this.encomenda.destinatario.textoBotao = "Alterar";
        }
        this.mostrarDetalhes =
          this.encomenda.servicoEnvio !== "Logistica Reversa";
        this.mostrarDetalhesReversa =
          this.encomenda.servicoEnvio === "Logistica Reversa";
        this.setAnalytics();
      }
    } catch (err) {
      if (err.status === 404) {
        this.infoRastreio = "Número de rastreamento não encontrado.";
      } else {
        this.infoRastreio =
          "Não foi possível obter os dados do rastreamento. Por favor tente novamente.";
      }
    }
  }

  public isLoggedIn(): boolean {
    return this.Auth.isLoggedIn();
  }

  public close() {
    this.emailVero = false;
  }

  public closeAlert(index: number) {
    this.alerts.splice(index, 1);
  }

  public async enviarEmail() {
    const properties = {
      nomeDestinatario: this.encomenda.destinatario.nome,
      emailDestinatario: this.encomenda.destinatario.email,
      nomeRemetente: this.encomenda.remetente.nome,
      emailRemetente: this.Auth.getCurrentUser().email,
      codigoRastreamento: this.numeroRastreio,
    };

    try {
      await this.Rastreamento.putEmailDestinatario({
        codigoRastreamento: properties.codigoRastreamento,
        novoEmail: properties.emailDestinatario,
      });

      if (properties.emailDestinatario) {
        this.emailVero = true;
        $("html, body").animate({ scrollTop: 0 }, 500);

        this.$timeout(() => {
          this.emailVero = false;
        }, 7000);
      }
    } catch (err) {
      this.addAlert(
        "Não foi possível atualizar o email, por favor tente novamente."
      );
    }
  }

  public mudouDataExibicao(index) {
    if (!index) {
      return true;
    }

    const dataIteracaoAtual = this.$filter("date")(
      this.encomenda.historico[index].dataHoraTs,
      "dd-MM-yyyy"
    );
    const dataIteracaoAnterior = this.$filter("date")(
      this.encomenda.historico[index - 1].dataHoraTs,
      "dd-MM-yyyy"
    );

    return dataIteracaoAtual !== dataIteracaoAnterior;
  }

  private addAlert(message: string) {
    this.alerts.push({
      type: "danger",
      msg: message,
    });
    $("html, body").animate({ scrollTop: 0 }, 500);
    this.$timeout(() => {
      this.closeAlert(0);
    }, 7000);
  }

  private setAnalytics() {
    const obj = {
      url: "/" + this.$state.current.name,
      email: this.Auth.getCurrentUser().email,
      loggedIn: this.isLoggedIn(),
      codigoRastreamento: this.numeroRastreio,
      RecipientCity: this.encomenda
        ? this.encomenda.destinatario.endereco.cidade
        : null,
      RecipientState: this.encomenda
        ? this.encomenda.destinatario.endereco.uf
        : null,
    };
  }
}
